(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const dialog = document.getElementById('snx-rec-dialog');
  if (!dialog) return;
  let launcher;
  let dock;
  let observer;
  const updateDock = () => {
    const next = mobile.matches ? document.querySelector('[data-snx-cart-summary]') : null;
    if (next !== dock) {
      if (observer) observer.disconnect();
      dock = next;
      if (dock) {
        observer = new ResizeObserver(() => document.body.style.setProperty('--snx-cart-summary-height', `${Math.ceil(dock.getBoundingClientRect().height)}px`));
        observer.observe(dock);
      }
    }
    document.body.classList.toggle('snx-has-cart-summary', !!dock);
    if (dock) document.body.style.setProperty('--snx-cart-summary-height', `${Math.ceil(dock.getBoundingClientRect().height)}px`);
    else document.body.style.removeProperty('--snx-cart-summary-height');
  };
  document.addEventListener('snx:cart-rendered', event => {
    updateDock();
    const cart = event.detail;
    const heading = document.querySelector('#mini__cart [data-drawer-title]');
    const labels = document.querySelector('[data-snx-cart-labels]');
    if (heading && labels) {
      const count = document.createElement('span');
      count.className = 'snx-cart-count';
      count.textContent = cart.item_count === 1 ? labels.dataset.one : labels.dataset.many.replace('999', String(cart.item_count));
      heading.replaceChildren(document.createTextNode(labels.dataset.title), count);
    }
    const drawer = document.querySelector('#mini__cart');
    if (drawer && document.body.classList.contains('side_Drawer_open') && !mobile.matches) {
      focusElementsRotation(window.jQuery(drawer));
      if (document.activeElement === document.body) drawer.querySelector('.yv_side_drawer_close')?.focus({preventScroll:true});
    }
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count < 100 ? cart.item_count : ''; el.style.display = cart.item_count ? '' : 'none'; });
  });
  const ready = () => {
    updateDock();
    const root = document.querySelector('[data-snx-full-cart]');
    if (root) new MutationObserver(updateDock).observe(root, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
  mobile.addEventListener('change', () => {
    updateDock();
    if (mobile.matches && document.body.classList.contains('side_Drawer_open') && document.querySelector('#mini__cart')) {
      window.location.assign(window.Shopify.routes.root + 'cart');
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-snx-continue]')) document.querySelector('#mini__cart .yv_side_drawer_close')?.click();
  });
  dialog.querySelector('[data-snx-close]').addEventListener('click', () => dialog.close());
  // Keep the theme's outside-click handler from closing the cart behind the picker.
  dialog.addEventListener('mouseup', event => event.stopPropagation());
  dialog.addEventListener('click', event => {
    event.stopPropagation();
    if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    }
  });
  dialog.addEventListener('keydown', event => event.stopPropagation());
  dialog.addEventListener('close', () => {
    if (launcher?.isConnected) launcher.focus({preventScroll:true});
  });
  dialog.addEventListener('submit', async event => {
    const form = event.target.closest('.snx-rec-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button.disabled) return;
    button.disabled = true;
    const error = form.querySelector('[data-snx-rec-error]');
    error.hidden = true;
    let added = false;
    try {
      const response = await fetch(form.action + '.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || dialog.dataset.error);
      added = true;
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error(dialog.dataset.error);
      const cart = await cartResponse.json();
      dialog.close();
      if (document.querySelector('[data-snx-full-cart]')) cartPageUpdate(cart);
      else buildCart(cart, false);
    } catch (failure) {
      if (added) window.location.assign(window.Shopify.routes.root + 'cart');
      else { error.textContent = failure.message || dialog.dataset.error; error.hidden = false; }
    } finally { if (!added) button.disabled = false; }
  });
  if (!customElements.get('snx-cart-recommendations')) customElements.define('snx-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-snx-track]');
      const previous = this.querySelector('[data-snx-prev]');
      const next = this.querySelector('[data-snx-next]');
      const sync = () => { previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      this.addEventListener('click', event => {
        const direction = event.target.closest('[data-snx-prev],[data-snx-next]');
        if (direction) track.scrollBy({left:track.clientWidth * (direction.hasAttribute('data-snx-prev') ? -1 : 1), behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
        const choose = event.target.closest('[data-snx-choose]');
        if (choose) {
          event.stopPropagation();
          launcher = choose;
          const content = choose.closest('.snx-rec-card').querySelector('[data-snx-options]').content.cloneNode(true);
          content.querySelector('[data-snx-dialog-title]').id = 'snx-rec-dialog-title';
          dialog.querySelector('[data-snx-dialog-content]').replaceChildren(content);
          dialog.showModal();
        }
      });
      track.addEventListener('scroll', sync, {passive:true});
      this.resize = new ResizeObserver(sync);
      this.resize.observe(track);
      requestAnimationFrame(sync);
    }
    disconnectedCallback() { this.resize?.disconnect(); }
  });
})();
